/* eslint-disable camelcase */
import { AlertVariants } from '@pmi/dsm-react/dist/types';

export type AlertCategory =
  | 'static'
  | 'product_quantity'
  | 'users_failed_invitations'
  | 'custom';
export type AlertSubCategory =
  | 'agreement_product_quantity_below_x'
  | 'agreement_product_fully_consumed'
  | 'users_failed_invitations'
  | 'custom';

export interface AlertData {
  product_name: string;
  dealid: string;
  quantity_remaining: number;
  failed_users_count: number;
}

export interface AlertMessage {
  id: string;
  type: AlertVariants;
  message?: string;
  category?: AlertCategory;
  subCategory?: AlertSubCategory;
  data?: AlertData;
}

export const AlertsSortOrder = {
  danger: 1,
  warning: 2,
  success: 3,
  info: 4,
  neutral: 5,
};
